module.exports = __webpack_public_path__ + "img/yezza_store.bcdc0f88.png";